import { Component, Input } from '@angular/core';
import { ProgressBarComponent } from '../progress-bar/progress-bar.component';

@Component({
  selector: 'app-progress-spinner',
  templateUrl: './progress-spinner.component.html',
  styleUrls: ['./progress-spinner.component.scss']
})
export class ProgressSpinnerComponent extends ProgressBarComponent {
  @Input() diameter: number = 65;
  // HACK: apply default value
  @Input() width: number = 0;

  constructor() {
    super();
  }

  ngOnChanges(): void {
    super.ngOnChanges();
  }
}
